import { GraphAnchor } from '../../../services/owner-graph.service';

/**
 * Ce qu'une palette rend en se fermant quand elle passe la main à l'autre.
 * `CommandPaletteService` le lit dans `afterClosed()` et ouvre la suivante :
 * les deux composants n'ont ainsi pas à se connaître, ni à connaître le service
 * qui les ouvre (qui, lui, les importe tous les deux).
 */
export type PaletteSwitch =
  | {
      switchTo: 'graph';
      /** La fiche à placer au centre ; `null` = celle de l'écran, à défaut la recherche du graphe. */
      anchor: GraphAnchor | null;
    }
  /** Retour à la recherche, sur la saisie précédente — ce que fait Cmd+K. */
  | { switchTo: 'search' };

export const isPaletteSwitch = (value: unknown): value is PaletteSwitch =>
  !!value && typeof value === 'object'
  && ((value as PaletteSwitch).switchTo === 'graph' || (value as PaletteSwitch).switchTo === 'search');

/** Données de la recherche (Cmd+K) : la saisie précédente, rendue au retour du graphe. */
export interface CommandPaletteData {
  query: string;
}

/** Cmd+Shift+K (Ctrl+Shift+K hors Mac) — le raccourci du graphe. */
export function isGraphShortcut(event: KeyboardEvent, isMac: boolean): boolean {
  const modifier = isMac ? event.metaKey : event.ctrlKey;
  return modifier && event.shiftKey && !event.altKey && event.key.toLowerCase() === 'k';
}
